var map = {
	"./air-nga-en/assets/main-banner.png": 12426,
	"./ais-tai-en/assets/main-banner.png": 17515,
	"./ais-tai-tha/assets/main-banner.png": 91959,
	"./demo-arabic/assets/main-banner.png": 98911,
	"./demo-et-en/assets/main-banner.png": 6494,
	"./demo-romanian/assets/main-banner.png": 54296,
	"./demo-um-en/assets/main-banner.png": 96895,
	"./dtac-tai-en/assets/main-banner.png": 4280,
	"./dtac-tai-tha/assets/main-banner.png": 12466,
	"./ethiotel-et-amh/assets/main-banner.png": 96036,
	"./ethiotel-et-en/assets/main-banner.png": 94481,
	"./mtn-cg-fr/assets/main-banner.png": 4156,
	"./mtn-ci-fr/assets/main-banner.png": 88450,
	"./mtn-cmr-fr/assets/main-banner.png": 53110,
	"./mtn-gha-en/assets/main-banner.png": 83369,
	"./mtn-nga-en/assets/main-banner.png": 35757,
	"./mtn-zam-en/assets/main-banner.png": 71967,
	"./saf-ke-en/assets/main-banner.png": 43558,
	"./saudi-uae-en/assets/main-banner.png": 24655,
	"./tlk-za-en/assets/main-banner.png": 17418,
	"./vc-za-en/assets/main-banner.png": 25590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91178;